var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFolderHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_folder_hidden"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    opacity: 0.7,
    d: "M4 4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H5.96112C5.96112 20 6.52506 20.7356 5.95968 19.9981C5.39429 19.2607 4.66763 18 4.66763 18C5.25578 17.0198 6.63704 15.0589 7.77967 14.0201C7.85051 13.9557 7.92316 13.891 7.99763 13.8261L7.58579 13.4142L10.4142 10.5858L11.495 11.6665C12.5364 11.2611 13.7083 11 15 11C18.0464 11 20.4262 12.4524 22 13.824V8C22 6.89543 21.1046 6 20 6H12L10 4H4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29291 13.7071L19.2929 23.7071L20.7071 22.2928L19.7894 21.3752C21.8508 19.9154 23 18 23 18C23 18 20 13 15 13C13.9094 13 12.914 13.2379 12.0241 13.6098L10.7071 12.2928L9.29291 13.7071ZM13.7066 15.2924C14.0983 15.1049 14.5369 15 15 15C16.6569 15 18 16.3431 18 18C18 18.4631 17.8951 18.9017 17.7076 19.2934L16.9323 18.518C16.9764 18.3528 17 18.1791 17 18C17 16.8954 16.1046 16 15 16C14.8209 16 14.6472 16.0236 14.482 16.0677L13.7066 15.2924Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10448 15.5187C7.74254 16.7624 7 18 7 18C7 18 10 23 15 23C15.5021 23 15.984 22.9496 16.4447 22.8589L14.5527 20.9669C13.2539 20.7727 12.2273 19.7461 12.0331 18.4473L9.10448 15.5187Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFolderHidden);
export default __webpack_public_path__ + "static/media/ic_action_folder_hidden.66257eef801936c3b5d2822d7ff32a90.svg";
export { ForwardRef as ReactComponent };